<template>
  <div class="calendarDocs">
    <h1 class="large-title">Range Calendar</h1>
    <div class="calendar">
      <label class="small-font">Period of Campaign</label>
      <v-date-picker
        v-model='startDate'
        class='date-input'
        :theme-styles='themeStyles'
        :popoverVisibility="'focus'">
        <input
          class="calendar-start"
          type='text'
          slot-scope='{ inputValue, updateValue }'
          disabled
          :value='inputValue'
          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
          @popover-did-appear='toggleBorder'
          @popover-did-disappear='toggleBorder'
          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
      </v-date-picker>
      <i class="icon-chevronright"></i>
      <v-date-picker
        v-model='endDate'
        :popoverVisibility="'focus'"
        :theme-styles='themeStyles'
        class='date-input'>
        <input
          class="calendar-end"
          type='text'
          slot-scope='{ inputValue, updateValue }'
          disabled
          :value='inputValue'
          @popover-did-appear='toggleBorder'
          @popover-did-disappear='toggleBorder'
          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
      </v-date-picker>
    </div>
    <div class="divider">
    </div>
    <h1 class="large-title">Single Calendar</h1>
    <div class="calendar">
      <label class="small-font">Period of Campaign</label>
      <v-date-picker
        v-model='singleDate'
        :popoverVisibility="'focus'"
        :theme-styles='themeStyles'
        class='date-input'>
        <input
          class="calendar-start"
          type='text'
          slot-scope='{ inputValue, updateValue }'
          disabled
          :value='inputValue'
          @popover-did-appear='toggleBorder'
          @popover-did-disappear='toggleBorder'
          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
      </v-date-picker>
    </div>
  </div>
</template>

<script>
import calendar from 'v-calendar'

export default {
  name: 'adx-calendar-docs',
  components: {
    'v-calendar': calendar
  },
  data(){
    return {
      startDate: new Date(),
      endDate: new Date(),
      singleDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
      
    }
  },
  methods: {
    toggleBorder(){
      this.isBorder = !this.isBorder;
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>